import React from "react";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";

import "./TimeLine.scss";
import Section from "../../UI/Others/Section";

import * as GlobalConstant from "../../Constants/GlobalConstant";

import { faPlus, faWrench, faCloudUploadAlt, faExternalLinkAlt, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const TimeLine = (props) => {

    const intl = useIntl();
    const title = intl.messages.timelineTitle;

    function Badge(props) {
        return (
            <div className={"timeline-badge " + props.className}>
                <FontAwesomeIcon icon={props.icon} className="icon" />
            </div>
        );
    }

    return (
        <div>
            <Section 
                title={title} 
                className="bg-blue"
            />

            <div className="row">
                <div className="col-md-12">
                    <ul className="timeline">
                        <li className="timeline-item">
                            <Badge icon={faPlus} className="bg-pink" />
                            <div className="timeline-panel">
                                <div className="timeline-heading">
                                    <h5 className="mt-0 text-uppercase">1. {intl.messages.timelineCardTitle1}</h5>

                                </div>
                                <div className="timeline-body">
                                    <p>{intl.messages.timelineCardText1}</p>
                                </div>
                                <div className="float-right">
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn-link-pink"
                                        href="https://web.openrainbow.com/#/subscribe"
                                    >
                                        <FontAwesomeIcon icon={faArrowRight} className="text-pink mr-1" />
                                        {intl.messages.timelineSignUp}
                                    </a>
                                </div>
                            </div>
                        </li>
                        <li className="timeline-item">
                            <Badge icon={faWrench} className="bg-orange" />
                            <div className="timeline-panel">
                                <div className="timeline-heading">
                                    <h5 className="mt-0 text-uppercase">2. {intl.messages.timelineCardTitle2}</h5>
                                </div>
                                <div className="timeline-body">
                                    <p>{intl.messages.timelineCardText2}</p>
                                </div>
                                <div className="float-right">
                                    <Link to="/doc/hub/getting-started"
                                        className="btn-link-orange"
                                    >
                                        <FontAwesomeIcon icon={faArrowRight} className="text-orange mr-1" />
                                        {intl.messages.timelineGetStarted}
                                    </Link>
                                </div>
                            </div>
                        </li>
                        <li className="timeline-item">
                            <Badge icon={faCloudUploadAlt} className="bg-green" />
                            <div className="timeline-panel">
                                <div className="timeline-heading">
                                    <h5 className="mt-0 text-uppercase">3. {intl.messages.timelineCardTitle3}</h5>
                                </div>
                                <div className="timeline-body">
                                    <p>{intl.messages.timelineCardText3}</p>
                                </div>

                                <div className="float-right">
                                    <Link to={(props.isAuthenticated) ? GlobalConstant.DASHBOARD_PATH : GlobalConstant.LOGIN_PATH}
                                        className="btn-link-green"
                                    >
                                        <FontAwesomeIcon icon={faArrowRight} className="text-green mr-1" />
                                        {(props.isAuthenticated) ? intl.messages.timelineOpen : intl.messages.timelineLogin}
                                    </Link>

                                </div>
                            </div>
                        </li>
                        <li className="timeline-item">
                            <Badge icon={faExternalLinkAlt} className="bg-blue" />
                            <div className="timeline-panel">
                                <div className="timeline-heading">
                                    <h5 className="mt-0 text-uppercase">4. {intl.messages.timelineCardTitle4}</h5>
                                </div>
                                <div className="timeline-body">
                                    <p>{intl.messages.timelineCardText4}</p>
                                </div>

                                <div className="float-right">
                                    <Link to={(props.isAuthenticated) ? GlobalConstant.DASHBOARD_PATH : GlobalConstant.LOGIN_PATH}
                                        className="btn-link-blue"
                                    >
                                        <FontAwesomeIcon icon={faArrowRight} className="text-blue mr-1" />
                                        {(props.isAuthenticated) ? intl.messages.timelineOpen : intl.messages.timelineLogin}

                                    </Link>
                                </div>


                            </div>
                        </li>
                        <li className="timeline-item"></li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

TimeLine.defaultProps = {
    isAuthenticated: false
}

export default (TimeLine);